import { gql } from '@apollo/client';
export const fetchSandboxForEntitlementForPPC = gql`
  query fetchSandboxForEntitlementForPPC(
    $id: String!
    $transactionAccountId: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      transactionAccountId
      sandboxEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        billingFrequency
        productId
        baseProduct
        billingStatus
        entitlementNumber
        productName
        transactionAccountId
        billingGroupId
        billedUsers
        latestPeriodEndDate
        edition
        cloudSiteHostname
        cloudSiteId
        trial
        isApp
        activeUsers
        provisioningStatus
        isFutureDatedSubscription
        relatesFromEntitlements {
          entitlementId
          relationshipType
        }
        scheduledChanges {
          subscriptionScheduleAction
        }
        linkedAppsId
        offering {
          pricingType
        }
      }
    }
  }
`;
